import { createClient } from "@supabase/supabase-js";
import { emitToast } from "../components/Toast";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Faltam VITE_SUPABASE_URL e/ou VITE_SUPABASE_ANON_KEY no .env.local");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

export const SUPABASE_FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;
export const SUPABASE_ANON = SUPABASE_ANON_KEY;

supabase.auth.onAuthStateChange((event, session) => {
  if (import.meta.env.DEV) {
    console.debug("[supabase.auth]", event, session ? "session=ok" : "session=null");
  }
  if (event === "TOKEN_REFRESHED" && !session) {
    emitToast("warning", "Sessão expirou. Faça login novamente.");
  }
});
